import { Company, CompanySettings } from '@domain/account/models/Company';
import { CompanyDTO } from '../dto/CompanyDTO';

export class CompanyMapper {
    static toModel(dto: CompanyDTO): Company {
        return {
            id: dto.id,
            name: dto.name,
            settings: CompanyMapper.normalizeSettings(dto.settings),
        };
    }

    private static normalizeSettings(settings: any | null): CompanySettings {
        if (!settings || typeof settings !== 'object') {
            return {};
        }
        const asBool = (value: unknown): boolean | undefined => {
            if (typeof value === 'string') return value === 'true';
            if (typeof value === 'boolean') return value;
            return undefined;
        };

        return {
            ...settings,
            tutorialCompleted: asBool(settings.tutorialCompleted),
            unlockDashboardCompleted: asBool(settings.unlockDashboardCompleted),
        };
    }
}